// emailTemplateTestSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TestResults, TestStatus } from '../EmailTemplateApiTest/types';

interface EmailTemplateTestState {
  results: TestResults;
  loading: { [testName: string]: boolean };
  resultsVisible: boolean;
}

const initialState: EmailTemplateTestState = {
  results: {},
  loading: {},
  resultsVisible: false,
};

export const emailTemplateTestSlice = createSlice({
  name: 'emailTemplateTest',
  initialState,
  reducers: {
    // Set result for a test
    setTestResult: (
      state,
      action: PayloadAction<{
        testName: string;
        status: TestStatus;
        data?: unknown;
        error?: string;
        response?: unknown;
      }>
    ) => {
      const { testName, status, data, error, response } = action.payload;
      state.results[testName] = {
        status,
        data,
        error,
        response,
        timestamp: Date.now(),
      };
    },

    // Set loading state for a test
    setTestLoading: (
      state,
      action: PayloadAction<{
        testName: string;
        loading: boolean;
      }>
    ) => {
      const { testName, loading } = action.payload;
      state.loading[testName] = loading;
    },

    // Toggle results visibility
    toggleResultsVisibility: (state) => {
      state.resultsVisible = !state.resultsVisible;
    },

    // Clear all results
    clearAllResults: (state) => {
      state.results = {};
      state.loading = {};
    },

    // Clear specific test result
    clearTestResult: (state, action: PayloadAction<string>) => {
      const testName = action.payload;
      delete state.results[testName];
      delete state.loading[testName];
    },

    // Set results visibility explicitly
    setResultsVisibility: (state, action: PayloadAction<boolean>) => {
      state.resultsVisible = action.payload;
    },
  },
});

export const {
  setTestResult,
  setTestLoading,
  toggleResultsVisibility,
  clearAllResults,
  clearTestResult,
  setResultsVisibility,
} = emailTemplateTestSlice.actions;

export default emailTemplateTestSlice.reducer;
